<div class="main-container">
  <lib-ngx-data-table class="data-table" [rowHeight]="60" [data]="rows" [columns]="columns"
    [selectionType]="undefined" [loading]="isLoading">
  </lib-ngx-data-table>

  <div class="paginator-bar">
    <mat-paginator
      [length]="totalCount"
      [pageIndex]="currentPage"
      [pageSize]="pageSize"
      [pageSizeOptions]="[10, 25, 50, 100]"
      showFirstLastButtons
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</div>
